import { Select } from '@seiue/ui'
import React from 'react'
import styled from 'styled-components'

import { createOptions } from './utils'

/**
 * 文件上传数量限制
 *
 * @param param - 参数
 * @param param.minCount - 最小数量
 * @param param.maxCount - 最大数量
 * @param param.isUserField - 是否为用户字段
 * @param param.onSelect - 选中状态发生变化时的回调
 * @returns React.ReactNode
 */
export const FileNumSetting: React.FC<{
  minCount?: number
  maxCount?: number
  isUserField?: boolean
  onSelect: (param: object) => void
}> = ({ minCount, maxCount, isUserField, onSelect }) => {
  const statusError = minCount && maxCount && minCount > maxCount
  return (
    <>
      <FileNumSettingWrapper>
        <div>最少上传</div>
        <Select
          disabled={!!isUserField}
          placeholder="请选择"
          options={createOptions(20)}
          status={statusError ? 'error' : undefined}
          value={minCount}
          onSelect={(v) => onSelect({ minCount: Number(v) })}
        />
      </FileNumSettingWrapper>
      <FileNumSettingWrapper>
        <div>最多上传</div>
        <Select
          disabled={!!isUserField}
          placeholder="请选择"
          options={createOptions(20)}
          status={statusError ? 'error' : undefined}
          value={maxCount}
          onSelect={(v) => onSelect({ maxCount: Number(v) })}
        />
      </FileNumSettingWrapper>
      {statusError ? (
        <ErrorWrapper>可选数量设置冲突，请调整</ErrorWrapper>
      ) : null}
    </>
  )
}

const FileSizeSettingWrapper = styled.div`
  width: 100%;
  height: 28px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  & > div {
    width: 78px;
    height: 28px;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    color: ${(props) => props.theme.text._2};
  }
  .ant-input-number-group-wrapper {
    width: 162px;
    .ant-input-number {
      height: 28px;
      border: transparent;
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
      background-color: ${(props) => props.theme.background._3};
    }
    .ant-input-number-group-addon {
      border: transparent;
      border-top-right-radius: 8px;
      border-bottom-right-radius: 8px;
      border-left: 1px solid ${(props) => props.theme.border.greyNormal};
      background-color: ${(props) => props.theme.background._3};
    }
    .ant-input-number-handler-wrap {
      display: none;
    }
  }
`

const FileNumSettingWrapper = styled(FileSizeSettingWrapper)`
  height: 32px;
  margin-bottom: 8px;
  &&& {
    .ant-select {
      width: 216px;
      height: 32px;
      border-radius: 8px;
    }
    .ant-select-selection-search-input {
      height: 28px;
    }
    .ant-select-status-error .ant-select-selector {
      border: 1px solid red;
      background-color: ${(props) => props.theme.background._3} !important;
    }
    .ant-select-selection-placeholder {
      line-height: 28px;
    }
  }
`

const ErrorWrapper = styled.div`
  color: #f54545;
  font-size: 12px;
  padding-left: 72px;
`
